export default __webpack_public_path__ + "static/media/appStore.bf74a6ae.svg";